/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ActionContextBooleanFunc from './ActionContextBooleanFunc';
import BindingSource from './BindingSource';
import EmptyBodyBehavior from './EmptyBodyBehavior';
import IPropertyFilterProvider from './IPropertyFilterProvider';

/**
 * The BindingInfo model module.
 * @module model/BindingInfo
 * @version V1
 */
class BindingInfo {
    /**
     * Constructs a new <code>BindingInfo</code>.
     * @alias module:model/BindingInfo
     */
    constructor() { 
        
        BindingInfo.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BindingInfo</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BindingInfo} obj Optional instance to populate.
     * @return {module:model/BindingInfo} The populated <code>BindingInfo</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BindingInfo();

            if (data.hasOwnProperty('bindingSource')) {
                obj['bindingSource'] = BindingSource.constructFromObject(data['bindingSource']);
            }
            if (data.hasOwnProperty('binderModelName')) {
                obj['binderModelName'] = ApiClient.convertToType(data['binderModelName'], 'String');
            }
            if (data.hasOwnProperty('binderType')) {
                obj['binderType'] = ApiClient.convertToType(data['binderType'], 'String');
            }
            if (data.hasOwnProperty('propertyFilterProvider')) {
                obj['propertyFilterProvider'] = IPropertyFilterProvider.constructFromObject(data['propertyFilterProvider']);
            }
            if (data.hasOwnProperty('requestPredicate')) {
                obj['requestPredicate'] = ActionContextBooleanFunc.constructFromObject(data['requestPredicate']);
            }
            if (data.hasOwnProperty('emptyBodyBehavior')) {
                obj['emptyBodyBehavior'] = EmptyBodyBehavior.constructFromObject(data['emptyBodyBehavior']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BindingInfo</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BindingInfo</code>.
     */
    static validateJSON(data) {
        // validate the optional field `bindingSource`
        if (data['bindingSource']) { // data not null
          BindingSource.validateJSON(data['bindingSource']);
        }
        // ensure the json data is a string
        if (data['binderModelName'] && !(typeof data['binderModelName'] === 'string' || data['binderModelName'] instanceof String)) {
            throw new Error("Expected the field `binderModelName` to be a primitive type in the JSON string but got " + data['binderModelName']);
        }
        // ensure the json data is a string
        if (data['binderType'] && !(typeof data['binderType'] === 'string' || data['binderType'] instanceof String)) {
            throw new Error("Expected the field `binderType` to be a primitive type in the JSON string but got " + data['binderType']);
        }
        // validate the optional field `propertyFilterProvider`
        if (data['propertyFilterProvider']) { // data not null
          IPropertyFilterProvider.validateJSON(data['propertyFilterProvider']);
        }
        // validate the optional field `requestPredicate`
        if (data['requestPredicate']) { // data not null
          ActionContextBooleanFunc.validateJSON(data['requestPredicate']);
        }

        return true;
    }


}



/**
 * @member {module:model/BindingSource} bindingSource
 */
BindingInfo.prototype['bindingSource'] = undefined;

/**
 * @member {String} binderModelName
 */
BindingInfo.prototype['binderModelName'] = undefined;

/**
 * @member {String} binderType
 */
BindingInfo.prototype['binderType'] = undefined;

/**
 * @member {module:model/IPropertyFilterProvider} propertyFilterProvider
 */
BindingInfo.prototype['propertyFilterProvider'] = undefined;

/**
 * @member {module:model/ActionContextBooleanFunc} requestPredicate
 */
BindingInfo.prototype['requestPredicate'] = undefined;

/**
 * @member {module:model/EmptyBodyBehavior} emptyBodyBehavior
 */
BindingInfo.prototype['emptyBodyBehavior'] = undefined;






export default BindingInfo;

